import React, { Component } from "react";
import { connect } from "react-redux";
import { deleteExhibitorFile } from "ActionsExhibitorsFile";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import _ from "lodash";
import { INSTANCE_URL, COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class ExhibitorListItem extends Component {
  deleteExhibitorFileCallback(exhibitorFile) {
    confirmAlert({
      title: "Delete",
      message: "This will permanently delete the Exhibitor file. Continue?",
      confirmLabel: "OK",
      cancelLabel: "CANCEL",
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            var { exhibitorfileid, exhibitorid } = this.props.exhibitorFile;
            this.props.deleteExhibitorFile(
              this.props.session,
              exhibitorfileid,
              exhibitorid,
              (result) => {
                if (result.error) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.showSuccess("Exhibitor file deleted successfully");
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    const { exhibitorFile } = this.props;
    var imgURL = `${INSTANCE_URL}/${exhibitorFile.filepath}`;

    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${imgURL})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "5px",
      backgroundPosition: "50% 50%",
    };

    var exhibitorid = `${exhibitorFile.exhibitorid}`;
    var exhibitorfileid = `${exhibitorFile.exhibitorfileid}`;
    var name = `${exhibitorFile.filename}`;
    var filetype = `${exhibitorFile.filetype}`;
    return (
      <tr key={exhibitorFile.exhibitorfileid}>
        <td>
          <div className="row">
            <div className="col-md-2 vcenter">
              <div style={style}></div>
            </div>
            <div className="col-md-6 vcenter">{name}</div>
          </div>
        </td>
        <td>{filetype}</td>
        <td>
          <div className="action-button-area">
            {/*<div className="action-button vcenter"><button className="btn btn-default btn-sm btn-edit" onClick={this.editExhibitorCallback.bind(this)}>EDIT</button></div>*/}
            <div className="action-button vcenter">
              <button
                className="btn btn-default btn-sm btn-delete"
                onClick={this.deleteExhibitorFileCallback.bind(this)}
              >
                X
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

function mapStateToProps({ session }) {
  return { session };
}

export default connect(mapStateToProps, {
  deleteExhibitorFile,
  showError,
  showSuccess,
})(ExhibitorListItem);
